"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Conjunction = exports.AdvancedSearchOperators = exports.INPUT_TYPE_MAP = exports.InputType = exports.AdvancedSearchInputType = exports.AdvancedSearchFilterOptionType = exports.Scope = exports.AdvancedSearchType = exports.ALLOWED_VALUES_URL_PREFIX = exports.SAVED_SEARCHES_SECTION_ID = void 0;
exports.SAVED_SEARCHES_SECTION_ID = "savedSearches";
exports.ALLOWED_VALUES_URL_PREFIX = "/advanced-searches/config/allowedValues";
var AdvancedSearchType;
(function (AdvancedSearchType) {
    AdvancedSearchType["Campaigns"] = "campaigns";
    AdvancedSearchType["Members"] = "members";
    AdvancedSearchType["Providers"] = "providers";
    AdvancedSearchType["UserSaved"] = "userSaved";
})(AdvancedSearchType = exports.AdvancedSearchType || (exports.AdvancedSearchType = {}));
var Scope;
(function (Scope) {
    Scope["Episource"] = "episource";
    Scope["Global"] = "global";
    Scope["Personal"] = "personal";
})(Scope = exports.Scope || (exports.Scope = {}));
var AdvancedSearchFilterOptionType;
(function (AdvancedSearchFilterOptionType) {
    AdvancedSearchFilterOptionType["SelectableList"] = "selectableList";
    AdvancedSearchFilterOptionType["Text"] = "text";
    AdvancedSearchFilterOptionType["Number"] = "number";
    AdvancedSearchFilterOptionType["Multiselect"] = "multiselect";
    AdvancedSearchFilterOptionType["DatePicker"] = "datePicker";
    AdvancedSearchFilterOptionType["SavedSearch"] = "savedSearch";
    AdvancedSearchFilterOptionType["Select"] = "select";
})(AdvancedSearchFilterOptionType = exports.AdvancedSearchFilterOptionType || (exports.AdvancedSearchFilterOptionType = {}));
var AdvancedSearchInputType;
(function (AdvancedSearchInputType) {
    AdvancedSearchInputType["Date"] = "date";
    AdvancedSearchInputType["MultiSelect"] = "multiselect";
    AdvancedSearchInputType["Number"] = "number";
    AdvancedSearchInputType["PickList"] = "picklist";
    AdvancedSearchInputType["Text"] = "text";
})(AdvancedSearchInputType = exports.AdvancedSearchInputType || (exports.AdvancedSearchInputType = {}));
var InputType;
(function (InputType) {
    InputType["Date"] = "DATE";
    InputType["Multiselect"] = "MULTISELECT";
    InputType["Number"] = "NUMBER";
    InputType["Picklist"] = "PICKLIST";
    InputType["Text"] = "TEXT";
})(InputType = exports.InputType || (exports.InputType = {}));
exports.INPUT_TYPE_MAP = Object.freeze({
    [AdvancedSearchInputType.PickList]: AdvancedSearchFilterOptionType.SelectableList,
    [AdvancedSearchInputType.MultiSelect]: AdvancedSearchFilterOptionType.Multiselect,
    [AdvancedSearchInputType.Text]: AdvancedSearchFilterOptionType.Text,
    [AdvancedSearchInputType.Number]: AdvancedSearchFilterOptionType.Number,
    [AdvancedSearchInputType.Date]: AdvancedSearchFilterOptionType.DatePicker,
    [InputType.Date]: AdvancedSearchFilterOptionType.DatePicker,
    [InputType.Multiselect]: AdvancedSearchFilterOptionType.Multiselect,
    [InputType.Number]: AdvancedSearchFilterOptionType.Number,
    [InputType.Picklist]: AdvancedSearchFilterOptionType.SelectableList,
    [InputType.Text]: AdvancedSearchFilterOptionType.Text,
});
var AdvancedSearchOperators;
(function (AdvancedSearchOperators) {
    AdvancedSearchOperators["Matches"] = "MATCHES";
    AdvancedSearchOperators["Equals"] = "EQUALS";
    AdvancedSearchOperators["NotEquals"] = "NOT_EQUALS";
    AdvancedSearchOperators["GreaterThan"] = "GREATER_THAN";
    AdvancedSearchOperators["GreaterThanOrEquals"] = "GREATER_THAN_OR_EQUALS";
    AdvancedSearchOperators["LessThan"] = "LESS_THAN";
    AdvancedSearchOperators["LessThanOrEquals"] = "LESS_THAN_OR_EQUALS";
    AdvancedSearchOperators["Included"] = "INCLUDED";
    AdvancedSearchOperators["NotIncluded"] = "NOT_INCLUDED";
    AdvancedSearchOperators["Exists"] = "EXISTS";
    AdvancedSearchOperators["NotExists"] = "NOT_EXISTS";
    AdvancedSearchOperators["ContainsAll"] = "CONTAINS_ALL";
    AdvancedSearchOperators["ContainsAny"] = "CONTAINS_ANY";
    AdvancedSearchOperators["NotContains"] = "NOT_CONTAINS";
    AdvancedSearchOperators["Contains"] = "CONTAINS";
})(AdvancedSearchOperators = exports.AdvancedSearchOperators || (exports.AdvancedSearchOperators = {}));
var Conjunction;
(function (Conjunction) {
    Conjunction["AND"] = "AND";
    Conjunction["OR"] = "OR";
})(Conjunction = exports.Conjunction || (exports.Conjunction = {}));
